import RbDoctorLocator from '@/elements/doctor-locator/rb-doctor-locator.vue'
import {
  ACTION_SET_COMPONENT_IS_LOADED_STATUS,
  ACTION_SHOW_DOCTOR_LOCATOR,
} from '@/scripts/store/doctor-locator/actions'
import Vue from 'vue'

class DoctorLocator {
  private vuexStore: any
  private selectorForInjection = '.rb-app__footer'

  inject({ vuexStore }: { vuexStore: any }) {
    this.vuexStore = vuexStore

    if (!vuexStore.getters['doctorLocator/componentIsLoaded']) {
      const parent = document.querySelector(this.selectorForInjection)

      const DoctorLocatorComponent = Vue.extend(RbDoctorLocator)
      const instance = new DoctorLocatorComponent({
        store: this.vuexStore,
      })

      instance.$mount()
      parent?.appendChild(instance.$el)

      this.vuexStore.dispatch(`doctorLocator/${ACTION_SET_COMPONENT_IS_LOADED_STATUS}`)
    }

    this.vuexStore.dispatch(`doctorLocator/${ACTION_SHOW_DOCTOR_LOCATOR}`)
  }
}

export default new DoctorLocator()
